import { render, staticRenderFns } from "./auditAuthOwnerUndoList.vue?vue&type=template&id=6920e00b&scoped=true"
import script from "./auditAuthOwnerUndoList.vue?vue&type=script&lang=js"
export * from "./auditAuthOwnerUndoList.vue?vue&type=script&lang=js"
import style0 from "./auditAuthOwnerUndoList.vue?vue&type=style&index=0&id=6920e00b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_29ccf6a1548590c1291b44f0faebdb79/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920e00b",
  null
  
)

export default component.exports